import Duck from 'extensible-duck';
import toast from 'simple-pure-toast';
import {get} from '../../utils/request';
import {checkHasElements, handlerRequestErrors, msjCommon, statusesCommon, typesCommon} from '../../utils/helpers';

const initialState = {
  message: '',
  status: '',
  loading: false,
  comboSubordinados: [],
  subordinadosLista: []
};

const getInitialState = ({statuses}) => ({
  ...initialState,
  status: statuses.NEW
});

export default new Duck({
  namespace: 'converti',
  store: 'common',
  consts: {
    statuses: [
      ...statusesCommon,
      'LOADING_COMBO_SUBORDINADOS',
      'LOADING_LISTA_SUBORDINADOS',
      'READY_COMBO_ASESORES',
      'READY_LISTA_SUBORDINADOS'
    ]
  },
  types: [
    ...typesCommon,
    'FETCH_PENDING_COMBO_SUBORDINADOS',
    'FETCH_FULLFILLED_COMBO_SUBORDINADOS',
    'FETCH_PENDING_LISTA_SUBORDINADOS',
    'FETCH_FULLFILLED_LISTA_SUBORDINADOS',
    'RESET_COMMON_DUCK'
  ],
  initialState: getInitialState,
  reducer: (state, action, { types, statuses }) => {
    switch (action.type) {

      case types.FETCH_PENDING_COMBO_SUBORDINADOS:
        return {
          ...state,
          comboSubordinados: [],
          status: statuses.LOADING_COMBOS_ASESORES
        };

      case types.FETCH_FULLFILLED_COMBO_SUBORDINADOS:
        return {
          ...state,
          comboSubordinados: checkHasElements(action.payload) ? action.payload : [],
          status: statuses.READY_COMBO_ASESORES
        };

      case types.FETCH_PENDING_LISTA_SUBORDINADOS:
        return {
          ...state,
          subordinadosLista: [],
          status: statuses.LOADING_LISTA_SUBORDINADOS
        };

      case types.FETCH_FULLFILLED_LISTA_SUBORDINADOS:
        return {
          ...state,
          subordinadosLista: checkHasElements(action.payload) ? action.payload : [],
          status: statuses.READY_LISTA_SUBORDINADOS
        };

      case types.CREATOR_FAILD:
        toast.error(msjCommon('fallo'), { description: action.payload.message, position: 'bottomRight' });
        return { ...state, status: statuses.ERROR };

      case types.LOADING_EFFECT:
        return {
          ...state,
          loading: action.loading
        };

      case types.RESET_COMMON_DUCK:
        return getInitialState({ statuses })

      default:
        return state;
    }
  },
  selectors: {
    root: (state) => state
  },
  creators: ({ types }) => ({

    getComboSubordinados: (requestPayload = {}) => async (dispatch, getState) => {
      try {
        const { paramId } = requestPayload;
        const { auth: { user: { userId } } } = getState();
        const params = { queryStringParameters: { idUsuario: paramId || userId } };

        dispatch({ type: types.FETCH_PENDING_COMBO_SUBORDINADOS });

        const { payload } = await get('/jerarquia', params);

        dispatch({
          type: types.FETCH_FULLFILLED_COMBO_SUBORDINADOS,
          payload: payload.map((({ correo: id, nombreCompleto: value }) => ({ id, value })))
        });

      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
      }
    },

    getSubordinadosLista: (requestPayload = {}) => async (dispatch, getState) => {
      try {
        const { paramId } = requestPayload;
        const { auth: { user: { userId } } } = getState();
        const params = { queryStringParameters: { idUsuario: paramId || userId } };

        dispatch({ type: types.FETCH_PENDING_LISTA_SUBORDINADOS });

        const { payload } = await get('/jerarquia', params);

        dispatch({
          type: types.FETCH_FULLFILLED_LISTA_SUBORDINADOS,
          payload
        });

      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
      }
    },

    resetCommonDuck: () => async (dispatch) => {
      dispatch({ type: types.RESET_COMMON_DUCK });
    }

  })
});
